import type {StreamingInfo} from '../pages/stream/types';

export const getFullDate = (date: string): string => {
    const dateAndTime = date.split('T');

    return dateAndTime[0].split('-').join('-');
};

export const timeToMinutes = (timeStr: string): number => {
    if (timeStr) {
        const [hour, minute] = timeStr.split(':').map(Number);
        return hour * 60 + minute;
    }
    return 0;
};

export const timeStringToSeconds = (timeString: string): number => {
    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    return hours * 3600 + minutes * 60 + seconds;
};

export const secondToMinute = (second: string): number => {
    return Math.ceil(+second / 60);
};

export const hourToMinutes = (hhmm: string): number => {
    const [hh, mm] = hhmm.split(':').map(Number);
    return hh * 60 + mm;
};

export const formatDate = (isoString: string): string => {
    const date = new Date(isoString);
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${month}.${day}`;
};

const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
};

export const convertTimestampToHumanReadableDate = (timeStamp: number): string => {
    return new Date(timeStamp).toLocaleString(undefined, options);
};

export const getTodayEvents = (slides: Array<{ date: string; events: Array<StreamingInfo> }>): Array<StreamingInfo> => {
    const now = new Date();
    const todayStr = `${now.getFullYear()}.${String(now.getMonth() + 1).padStart(2, '0')}.${String(now.getDate()).padStart(2, '0')}`;
    return slides?.find((slide) => slide.date === todayStr)?.events ?? [];
};

export const findCurrentScheduleIndex = (scheduleData: Array<StreamingInfo>) => {
    const now = new Date();
    const nowMinutes = now.getHours() * 60 + now.getMinutes();

    return scheduleData.findIndex((event) => {
        const [startHour, startMin] = event.start_time.split(':').map(Number);
        const [endHour, endMin] = event.end_time.split(':').map(Number);

        const startMinutes = startHour * 60 + startMin;
        const endMinutes = endHour * 60 + endMin;

        return nowMinutes >= startMinutes && nowMinutes < endMinutes;
    });
};
